import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { StyledContent, StyledSection } from './TeamWhy.styled';

const TeamWhy: React.FC = () => {
  const { t } = useI18n('web');

  return (
    <StyledSection>
      <Heading2 editorial>{t('team.why.title')}</Heading2>
      <StyledContent>
        <div
          dangerouslySetInnerHTML={{
            __html: t('team.why.desc')
          }}
        ></div>
      </StyledContent>
    </StyledSection>
  );
};

export default TeamWhy;
